module.exports = __webpack_public_path__ + "static/media/BLUSH_5472.9dc423a4.jpg";